import React from 'react';
var ProcessSearchContext = React.createContext({
    name: '@@root',
});
export var ProcessSearchProvider = ProcessSearchContext.Provider;
export var ProcessSearchConsumer = ProcessSearchContext.Consumer;
export default ProcessSearchContext;
//# sourceMappingURL=process-search-context.js.map